import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { isDefined } from '@freelancer/utils';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';
import { CustomTrackingEvent, TrackingEventData } from './tracking.model';

// This is just the common event this tracking will still accept any custom event name

export enum OutBrainPixelTrackingEventName {
  PAGE_VISIT = 'PageVisit',
  NHM_POST_PROJECT = 'NHM Post Project',
  NHM_POST_CONTEST = 'NHM Post Contest',
  HM_POST_PROJECT = 'HM Post Project',
}

@Injectable()
export class OutbrainPixelTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    @Inject(TRACKING_CONFIG) private config: TrackingConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isEnabled =
      isDefined(this.config.outbrainPixelId) &&
      isPlatformBrowser(this.platformId);
  }

  trackPageView(): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      this.trackEvent(OutBrainPixelTrackingEventName.PAGE_VISIT);
    });
  }

  trackCustomEvent(payload: CustomTrackingEvent & TrackingEventData): void {
    if (!this.isEnabled || !isDefined(payload.outBrainEventName)) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      this.trackEvent(payload.outBrainEventName);
    });
  }

  // Snippet taken from T251875
  private toArray(object: any) {
    return Object.prototype.toString.call(object) === '[object Array]'
      ? object
      : [object];
  }

  private loadTrackingSnippet(): void {
    const OB_ADV_ID = this.config.outbrainPixelId;
    if (window.obApi) {
      window.obApi.marketerId = this.toArray(window.obApi.marketerId).concat(
        this.toArray(OB_ADV_ID),
      );
      return;
    }
    window.obApi = function obApi() {
      if (window.obApi.dispatch) {
        // eslint-disable-next-line prefer-rest-params, prefer-spread
        window.obApi.dispatch.apply(window.obApi, arguments);
      } else {
        // eslint-disable-next-line prefer-rest-params
        window.obApi.queue.push(arguments);
      }
    };
    window.obApi.version = '1.1';
    window.obApi.loaded = true;
    window.obApi.marketerId = OB_ADV_ID;
    window.obApi.queue = [];

    const e = document.createElement('script');
    e.async = true;
    e.src = '//amplify.outbrain.com/cp/obtp.js';
    const s = document.getElementsByTagName('script')[0];
    (s.parentNode as Node).insertBefore(e, s);
  }

  private trackEvent(eventName: string) {
    window.obApi('track', eventName);
  }
}
